"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useContactActionsContext = exports.ContactActionsContext = void 0;
var _reactUtils = require("@cian/react-utils");
const {
  useContext: useContactActionsContext,
  Context: ContactActionsContext
} = (0, _reactUtils.makeContextModule)({
  contextName: 'ContactActionsContext',
  defaultValue: {
    mobileButtonBackground: 'gray6_100'
  }
});
exports.ContactActionsContext = ContactActionsContext;
exports.useContactActionsContext = useContactActionsContext;